const cartItem = {
    template: `<span ng-if="$ctrl.cartCount > 0" class="badge badge-assertive">{{ $ctrl.cartCount }}</span>`,
    controller: function($scope, localStorageService) {
        this.$scope = $scope;
        this.localStorageService = localStorageService;

        this.getCartCount = () => {
            let cart = this.localStorageService.get('cart');
            if (!cart) {
                return 0;
            } else {
                return JSON.parse(cart).length;
            }
        }

        this.cartCount = this.getCartCount();

        this.$scope.$on('cartChanged', (event, { count }) => {
            this.cartCount = count;
        });


    }
};

export default cartItem;


/** WEBPACK FOOTER **
 ** ./src/app/directives/cartItem/cartItem.js
 **/